import { render, staticRenderFns } from "./chatPDF-home.vue?vue&type=template&id=6065a79c&scoped=true&"
import script from "./chatPDF-home.vue?vue&type=script&lang=js&"
export * from "./chatPDF-home.vue?vue&type=script&lang=js&"
import style0 from "./chatPDF-home.vue?vue&type=style&index=0&id=6065a79c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065a79c",
  null
  
)

export default component.exports